document.addEventListener("DOMContentLoaded", () => {
    init_faq_accordions(document, true);
    observe_accordion_height();
    observe_media_boxes();
    hide_all_faqs();

    const mbContainer = document.querySelector(".ff_media_boxes .mb_items");
    if (mbContainer && window.Isotope) {
        let isoWait = setInterval(() => {
            if (mbContainer._isotope) {
                clearInterval(isoWait);
                const iso = mbContainer._isotope;

                // Smooth transitions
                iso.options.transitionDuration = '0.45s';
                iso.options.hiddenStyle = { opacity: 0, transform: 'translateY(10px) scale(0.97)' };
                iso.options.visibleStyle = { opacity: 1, transform: 'translateY(0) scale(1)' };

                // Start as relative to remove extra white space
                mbContainer.style.position = 'relative';
                recalc_mb_items_height_debounced();

                // After first layout, switch to absolute for smooth filtering
                const switchToAbsolute = () => {
                    mbContainer.style.position = 'absolute';
                    iso.layout(); // recalc Isotope positions
                };

                const images = mbContainer.querySelectorAll('img');
                let loaded = 0;
                if (images.length === 0) {
                    switchToAbsolute();
                } else {
                    images.forEach(img => {
                        if (img.complete) loaded++;
                        else img.addEventListener('load', () => { loaded++; if (loaded === images.length) switchToAbsolute(); });
                    });
                }

                // Extend Isotope filter for search
                const originalFilter = iso.options.filter || (() => true);
                iso.options.filter = function(i, el) {
                    if (typeof el === 'undefined' && typeof i === 'object') el = i;

                    // Base filter (from your Media Boxes)
                    const filterResult = originalFilter(i, el);

                    // SEARCH: post title + FAQ questions
                    const searchValue = mbContainer.dataset.searchValue || '';
                    if (!searchValue) return filterResult;

                    const regex = new RegExp(searchValue, 'gi');
                    let text = el.dataset.postTitle || '';
                    if (el.dataset.faqQuestions) {
                        text += ' ' + el.dataset.faqQuestions;
                    }

                    const searchResult = !!text.match(regex);
                    return filterResult && searchResult;
                };

                // Listen to search input
                const searchInput = document.querySelector('.ff_media_boxes_search input[type="search"]');
                if (searchInput) {
                    searchInput.addEventListener('input', () => {
                        mbContainer.dataset.searchValue = searchInput.value.trim();
                        iso.arrange();
                        recalc_mb_items_height_debounced();
                    });
                }

                // Force re-layout after filter/load
                const relayout = () => requestAnimationFrame(() => iso.layout());
                document.addEventListener("mediaBoxesAfterFilter", relayout);
                document.addEventListener("mediaBoxesAfterLoad", relayout);
            }
        }, 50);
    }
});

/* Initialize accordions */
function init_faq_accordions(context = document, openFirst = false) {
    context.querySelectorAll(".ff-faq-accordion:not([data-faq-initialized])").forEach(el => {
        new FAQ_Accordion(el, openFirst);
        el.dataset.faqInitialized = "true";
    });
}

/* Collapse all FAQs immediately */
function hide_all_faqs(context = document) {
    context.querySelectorAll(".ff-faq-accordion .group").forEach(group => {
        group.classList.remove("active");
        const content = group.querySelector(".group-content");
        if (content) {
            content.style.height = "0px";
            content.style.overflow = "hidden";
        }
    });
}

/* Recalculate container height */
function recalc_mb_items_height() {
  const container = document.querySelector(".ff_media_boxes .mb_items");
  if (!container) return;
  let maxBottom = 0;
  Array.from(container.children).forEach(item => {
    if (item.nodeType !== 1 || item.classList.contains('mb_hidden')) return;
    const bottom = item.offsetTop + item.offsetHeight;
    if (bottom > maxBottom) maxBottom = bottom;
  });
  container.style.height = maxBottom + "px";
}

/* Debounced height recalculation */
function recalc_mb_items_height_debounced() {
    clearTimeout(recalc_mb_items_height_debounced._timer);
    recalc_mb_items_height_debounced._timer = setTimeout(recalc_mb_items_height, 50);
}

/* Observe dynamically added accordions from Media Boxes */
function observe_media_boxes() {
    const container = document.querySelector(".ff_media_boxes .mb_items");
    if (!container) return;

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;
                setTimeout(() => {
                    init_faq_accordions(node, false);
                    observe_accordion_height(node);
                    recalc_mb_items_height_debounced();
                }, 400);
            });
        });
    });

    observer.observe(container, { childList: true, subtree: true });
}

/* Observe height changes of all group-content to recalc container */
function observe_accordion_height(context = document) {
    context.querySelectorAll(".ff-faq-accordion .group-content").forEach(content => {
        content.addEventListener("transitionend", recalc_mb_items_height_debounced);
    });
}

/* FAQ Accordion Class */
export default class FAQ_Accordion {
    constructor(el, openFirst = false) {
        this.el = el;
        this.groups = el.querySelectorAll(".group");
        if (!this.groups.length) return;
        this.init_accordion(openFirst);
    }

    init_accordion(openFirst) {
        this.groups.forEach((group, index) => {
            const heading = group.querySelector(".group-heading");
            const content = group.querySelector(".group-content");
            if (!heading || !content) return;

            // Start collapsed
            content.style.height = "0px";
            content.style.overflow = "hidden";
            content.style.transition = "height 0.35s ease";

            // Open first group only if allowed
            if (openFirst && index === 0) {
                group.classList.add("active");
                this.expand_content(content);
            }

            heading.addEventListener("click", () => {
                const wasActive = group.classList.contains("active");

                // Close all others
                this.groups.forEach(g => {
                    if (g === group && !wasActive) return; 
                    g.classList.remove("active");
                    const c = g.querySelector(".group-content");
                    if (c) this.collapse_content(c);
                });

                if (!wasActive) {
                    group.classList.add("active");
                    this.expand_content(content);
                } else {
                    this.collapse_content(content);
                }

                recalc_mb_items_height_debounced();
            });
        });
    }

    expand_content(content) {
        const naturalHeight = content.scrollHeight;
        content.style.height = naturalHeight + "px";

        content.addEventListener("transitionend", () => {
            content.style.height = "auto";
            recalc_mb_items_height_debounced();
        }, { once: true });
    }

    collapse_content(content) {
        const currentHeight = content.offsetHeight;
        if (currentHeight === 0) return;

        content.style.height = currentHeight + "px"; 
        content.offsetHeight; 
        content.style.height = "0px"; 

        content.addEventListener("transitionend", () => {
            content.style.overflow = "hidden";
            recalc_mb_items_height_debounced();
        }, { once: true });
    }
}

/*  For Search  */
function addDataAttributesForSearch() {
    const stopWords = ['a','an','the','is','to','do','I','of','for','and','in','on','with']; // ignore common words

    function extractImportantWords(text) {
        return text
            .toLowerCase()
            .replace(/[^\w\s]/g, '')      
            .split(/\s+/)                  
            .filter(word => !stopWords.includes(word)) 
            .join(' ');                     
    }

    document.querySelectorAll(".ff_media_boxes .mb_item").forEach(item => {
        if (item.dataset.postTitle) return; 

        // Get post title
        const titleEl = item.querySelector(".faq-item .title");
        let titleText = titleEl ? titleEl.textContent.trim() : '';
        item.dataset.postTitle = extractImportantWords(titleText);

        // Get all FAQ questions from repeater
        const questionsEls = item.querySelectorAll(".faq-group .heading");
        if (questionsEls.length) {
            const questions = Array.from(questionsEls).map(q => extractImportantWords(q.textContent.trim()));
            item.dataset.faqQuestions = questions.join(" ");
        }
    }); 
}

document.addEventListener("DOMContentLoaded", () => {
    const mbContainer = document.querySelector(".ff_media_boxes .mb_items");

    if (mbContainer) {
        // Set data attributes initially
        addDataAttributesForSearch(mbContainer);

        document.addEventListener("mediaBoxesAfterLoad", () => {
            addDataAttributesForSearch(mbContainer);
        });

        // Search input
        const searchInput = document.querySelector('.ff_media_boxes_search input[type="search"]');
        if (searchInput && window.Isotope && mbContainer._isotope) {
            const iso = mbContainer._isotope;

            searchInput.addEventListener('input', () => {
                const value = searchInput.value.trim();
                mbContainer.dataset.searchValue = value;

                iso.arrange();
                recalc_mb_items_height_debounced();
            });
        }
    }
});
